import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { DomainAddonPrice } from './../../models/DomainAddonPrice';

@Injectable({ providedIn: 'root' })
export class DomainAddonPriceService {

  constructor(private http: HttpClient) { }

  list(): Observable<DomainAddonPrice[]> {
    return this.http.get<DomainAddonPrice[]>(`${environment.apiUrl}/admin/domain-addon-prices`);
  }

  create(price: Partial<DomainAddonPrice>): Observable<DomainAddonPrice> {
    return this.http.post<DomainAddonPrice>(`${environment.apiUrl}/admin/domain-addon-prices`, price);
  }

  update(id: string, changes: Partial<DomainAddonPrice>): Observable<DomainAddonPrice> {
    return this.http.put<DomainAddonPrice>(`${environment.apiUrl}/admin/domain-addon-prices/${id}`, changes);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/admin/domain-addon-prices/${id}`);
  }
}
